const testimonials = [
  {
    name: "VP Operations, Devon Energy",
    location: "Downtown OKC",
    rating: 5,
    text: "I received a last-minute assignment to Dubai and realized my passport had expired during COVID when I was not traveling. Fast Passport Center had my renewal processed and back to me in four business days. I made my flight out of OKC without any issues. Incredibly professional team — they understood the urgency immediately and kept me updated throughout.",
    service: "Emergency Renewal",
  },
  {
    name: "Sgt. James M.",
    location: "Tinker AFB, Midwest City",
    rating: 5,
    text: "We got PCS orders to Germany with 45 days notice. My wife's passport had expired and our daughter had never had one. Fast Passport Center coordinated both renewals and the new child passport in six business days. They even helped us navigate the Tinker AFB passport office for the acceptance step. Outstanding support for military families.",
    service: "Military PCS Processing",
  },
  {
    name: "Dr. Priya S.",
    location: "OU Health, Oklahoma City",
    rating: 5,
    text: "I was invited to present at a medical conference in Geneva with three weeks notice. My passport was valid but only had four months left — many countries require six months. Fast Passport Center got my renewal back in five business days. I made my conference and my presentation went great. Highly recommend for medical professionals.",
    service: "Expedited Renewal",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function OKCTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Central Oklahoma Travelers Say About Our Emergency &amp; Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Oklahoma City, Midwest City, Moore, and Yukon travelers who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}